import React, { useState } from "react";
import { Modal, Button, Form,Badge  } from "react-bootstrap";

const AddTicketDetails = ({ show, handleClose }) => {

    const [users, setUsers] = useState(["Vaughan Lewis"]);
  const [input, setInput] = useState("");
  const [showInput, setShowInput] = useState(false);

  const handleAddUser = () => {
    if (input.trim() !== "") {
      setUsers([...users, input.trim()]);
      setInput("");
      setShowInput(false);
    }
  };

  const handleRemove = (index) => {
    const updated = users.filter((_, i) => i !== index);
    setUsers(updated);
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: "600" }}>
          Add Ticket
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Form>

          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control placeholder="Enter Title" />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Event Category</Form.Label>
            <Form.Select>
              <option>Select</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Subject</Form.Label>
            <Form.Control placeholder="Enter Subject" />
          </Form.Group>

       <Form.Group className="mb-3">
      <Form.Label>Assign To</Form.Label>

      <div
        style={{
          border: "1px solid #ddd",
          borderRadius: "6px",
          padding: "6px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "6px",
          minHeight: "40px",
        }}
      >
        {/* Chips */}
        {users.map((user, index) => (
          <Badge
            key={index}
            bg="light"
            text="dark"
            style={{
              padding: "6px 10px",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {user}
            <span
              style={{ cursor: "pointer", fontWeight: "bold" }}
              onClick={() => handleRemove(index)}
            >
              ×
            </span>
          </Badge>
        ))}

        {/* Input OR Add New */}
        {showInput ? (
          <input
            autoFocus
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onBlur={handleAddUser}
            onKeyDown={(e) => e.key === "Enter" && handleAddUser()}
            style={{
              border: "none",
              outline: "none",
              minWidth: "100px",
            }}
          />
        ) : (
          <span
            onClick={() => setShowInput(true)}
            style={{
              color: "#6c757d",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Add new
          </span>
        )}
      </div>
    </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Ticket Description</Form.Label>
            <Form.Control as="textarea" rows={3} placeholder="Add Question" />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Priority</Form.Label>
            <Form.Select>
              <option>Select</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select>
              <option>Select</option>
            </Form.Select>
          </Form.Group>

        </Form>
      </Modal.Body>

      <Modal.Footer style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          onClick={handleClose}
          style={{
            background: "#e5e7eb",
            border: "none",
            color: "#111",
          }}
        >
          Cancel
        </Button>

        <Button
          style={{
            background: "#ff6b00",
            border: "none",
          }}
        >
          Add Ticket
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddTicketDetails;